
















import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import Datepicker from "vuejs-datepicker";
import { ja } from "vuejs-datepicker/dist/locale";
import { Moment } from "@/typescript/lib/common/moment";
import { DatepickerElement } from "@/typescript/packages/datepicker/types";
export { DatepickerElement };
const moment = new Moment("YYYY/MM/DD");
const today = moment.getFormatDate();

@Component({
  components: {
    Datepicker
  }
})
export default class DatepickerComponent extends Vue {
  $refs!: {
    datepicker: DatepickerElement;
  };
  @Prop({
    default: today
  })
  value!: string;

  @Prop({
    default: ""
  })
  width!: string;

  @Prop({
    default: false
  })
  isDisabled!: boolean;

  @Prop({
    default: false
  })
  hasError!: boolean;

  @Prop({
    default: "day"
  })
  minView!: "year" | "month" | "day";

  /**
   * datepicker表示用のフォーマット
   * https://www.npmjs.com/package/vuejs-datepicker#date-formatting
   */
  @Prop({
    default: "yyyy/MM/dd"
  })
  format!: string;

  /**
   * 出力用moment.jsのフォーマット
   * https://momentjs.com/docs/#/displaying/format/
   */
  @Prop({
    default: "YYYY/MM/DD"
  })
  outputFormat!: string;

  @Emit()
  change(value: string): string {
    if (value) {
      const formatMoment = new Moment(this.outputFormat, value, "YYYY/MM/DD");
      return formatMoment.getFormatDate();
    }

    return "";
  }

  mounted() {
    this.change(this.value);
  }

  get internalValue(): string {
    return this.value;
  }

  set internalValue(value: string) {
    this.change(value);
  }

  showCalendar() {
    if (this.$refs.datepicker.isOpen) this.$refs.datepicker.close(true);
    const pickerInput: HTMLInputElement = this.$refs.datepicker.$el.querySelector(
      "input"
    ) as HTMLInputElement;
    pickerInput.focus();
    this.$refs.datepicker.showCalendar();
  }

  locale = ja;
}
